import {
  Box,
  Button,
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import { SecondaryButton } from "components/base/atoms/HJSButton";
import { useGetUserProfileQuery } from "queries";
import { useUpdateVisited } from "queries/Jobs";
import React, { FC } from "react";

import ScoresInformation from "./ScoresInformation";

interface IJobDescriptionModal {
  isOpen: boolean;
  handleOpen: () => void;
}

const ScoresInformationModal: FC<IJobDescriptionModal> = ({
  isOpen,
  handleOpen,
}) => {
  const { data: userData } = useGetUserProfileQuery();
  const { mutate: updateVisited } = useUpdateVisited();

  return (
    <Modal
      isOpen={isOpen}
      // closeOnOverlayClick={false}
      onClose={() => undefined}
      isCentered
      // size={{
      //   base: "sm",
      //   md: "xl",
      //   // lg: "xl",
      // }}
      // size={userData?.group === "T1" ? "lg" : ""}
      scrollBehavior="inside"
    >
      <ModalOverlay />
      <ModalContent
        maxW={{
          sm: "90vw",
          md: userData?.group === "T1" ? "600px" : "",
          xl: userData?.group === "T1" ? "600px" : "1000px",
        }}
        width="full"
      >
        <ModalHeader
          fontSize={[18, 18, 24]}
          borderBottom="1px solid rgba(0, 0, 0, 0.48);"
        >
          Information about Scores
        </ModalHeader>
        {/* <ModalCloseButton /> */}
        <Box /* maxH="70vh" */ overflowY="auto" px={5} py={3}>
          <ScoresInformation alreadyOpen={true} />
        </Box>
        <ModalFooter>
          <SecondaryButton
            fontSize={[14, 14, 20]}
            onClick={() => {
              handleOpen();
              !(userData?.visited as boolean) && updateVisited();
            }}
          >
            I understand!
          </SecondaryButton>
          {/* <Button>I Understand</Button> */}
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ScoresInformationModal;
